import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import OrderCancelService from "services/OrderCancelService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getOrderCancelConfig = createAsyncThunk(
  "setting/order-cancel/getOrderCancelConfig",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderCancelService.getOrderCancelConfig();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateOrderCancelConfig = createAsyncThunk(
  "setting/order-cancel/updateOrderCancelConfig",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await OrderCancelService.updateOrderCancelConfig(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllRefundList = createAsyncThunk(
  "setting/order-cancel/getAllRefundList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderCancelService.getAllRefundList();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateOrderCancelRefund = createAsyncThunk(
  "setting/order-cancel/updateOrderCancelRefund",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await OrderCancelService.updateOrderCancelRefund(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  orderCancelConfig: {},
  refundList: [],
};
export const orderCancelSlice = createSlice({
  name: "setting-order-cancel",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderCancelConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrderCancelConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.orderCancelConfig = action.payload;
      })
      .addCase(getOrderCancelConfig.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllRefundList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRefundList.fulfilled, (state, action) => {
        state.loading = false;
        state.refundList = action.payload;
      })
      .addCase(getAllRefundList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateOrderCancelConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOrderCancelConfig.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateOrderCancelConfig.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateOrderCancelRefund.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOrderCancelRefund.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateOrderCancelRefund.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = orderCancelSlice.actions;

export default orderCancelSlice.reducer;
